import { Component, OnInit, ViewChild } from '@angular/core';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
  import Keyboard from 'simple-keyboard';
  import { TotemService } from '../totem.service';
  import { TipoAccesos } from '../servicios/accesos';
import { ActivatedRoute } from '@angular/router';
import { Tienda } from '../tiendas/tienda';
import * as moment from 'moment';

@Component({
  selector: 'app-buscar',
  templateUrl: './buscar.component.html',
  styleUrls: ['./buscar.component.css']
})
export class BuscarComponent implements OnInit {
  value;
  teclado = false;
  menu = true;
  keyboard: Keyboard;
  commonKeyboardOptions = {
    onKeyPress: (button: string) => this.onKeyPress(button)
  };
  // tiendas
  tiendas: Array<Tienda>;
  tiendasfil: Array<Tienda>;
  otherTiendasresult: Array<Tienda>;
  contienen: Array<Tienda>;
  contienentags: Array<Tienda>;

  comienzan = true;
  contienentienda = false;
  tienetag = false;

  listadetiendas: Array<Tienda>;
  todasLasTiendas: Array<Tienda>;
  // servicios
  tipoAccesos: Array<TipoAccesos> = [];
  accesosfiltrados: Array<TipoAccesos>;
  resultAccesos: Array<TipoAccesos>;
  // eventos
  listaeventos = [];
  eventosresult = [];
  // configuracion swiper
  config: SwiperConfigInterface =
  {
    a11y: true,
    direction: 'horizontal',
    observer: true,
    spaceBetween: 10,
    slidesPerView: 5,
    simulateTouch:true,
    allowTouchMove:true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.carousel__arrow--prev',
      prevEl: '.carousel__arrow--next'
    },
    breakpoints: {
        1024: {
            slidesPerView: 5.5
        }
    }
    };
  constructor(
    private totemService: TotemService,
    private activatedRoute: ActivatedRoute) { }

    async ngOnInit() {
      window.addEventListener('scroll', this.scrollevent, true);
      try {
        // llamar tiendas
        const tiendas = await this.totemService.getTiendas().toPromise();
        this.tiendas  = tiendas.map((tienda: any) => new Tienda(tienda));
        const tiendasfil = [];
        for (const tienda of this.tiendas) {
          if (tienda.estado.toString() === 'Habilitado' ||  tienda.estado.toString() === 'Proximamente') {
            if (tienda.logo) {
              tiendasfil.push(tienda);
            }
          }
        }
        this.listadetiendas = tiendasfil;
        // this.otherTiendasresult = tiendasfil;
        this.otherTiendasresult = this.sortByKey(this.listadetiendas);
        this.todasLasTiendas = this.sortByKey(this.tiendas);
        //llamar accesos 
        const tipoAccesos = await this.totemService.getTipoAccesos().toPromise();
        this.tipoAccesos  = tipoAccesos.map(tipoAcceso => new TipoAccesos(tipoAcceso));
        const servicios = [];
        for (const ser of this.tipoAccesos) {
          if (ser.Visible === 1) {
            servicios.push(ser);
          }
        }
        this.accesosfiltrados = servicios;
        this.resultAccesos = servicios;
        // llamar eventos
        const eventoslist = await this.totemService.geteventos().subscribe(eventos => {
          for (const even of eventos) {
            if (even.tipo_evento === 'Evento') {
              if (even.publicado === 1) {
                if (moment().isBetween(even.dia_inicio, even.dia_termino)) {
                  even.horaini = even.hora_inicio.substr(0, 5);
                  even.horafin = even.hora_termino.substr(0, 5);
                  this.listaeventos.push(even);
                }
              }
            }
          }
          this.eventosresult = this.listaeventos;
          console.log('las', this.eventosresult);
        });

      } catch (err) {
        console.error(err);
      }
    }
    public onIndexChange(index: number): void {
        // console.log('Swiper index: ', index);
        this.cancelartimer();
    }

    public onSwiperEvent(event: string): void {
        // console.log('Swiper event: ', event);
        this.cancelartimer();
    }
  ngAfterViewInit(): void {
    this.keyboard = new Keyboard({
      ...this.commonKeyboardOptions,
      layout: {
        default: [
          '1 2 3 4 5 6 7 8 9 0 {bksp}',
          'q w e r t y u i o p',
          'a s d f g h j k l ñ',
          'z x c v b n m & ` {Cancelar}',
          '{space}']
        },

      display: {
        '{Cancelar}': ' Cancelar ',
        '{bksp}': ' ⌫',
        '{space}': '<i class="material-icons"></i>',
      },
      useButtonTag: true,
      onChange: input => this.onChange(input),
    });
  }
  onKeyPress = (button: string) => {
    if (button === '{Cancelar}' ) {
      setTimeout(() => {
        this.desplegarteclado();
      }, 100);
    }
  }
  public desplegarteclado() {
    this.value = '';
    this.keyboard.setInput('');
    this.filterTiendas('');
    this.filterAccesos('');
    this.filterEventos('');
    this.teclado = !this.teclado;
    this.menu = !this.menu;
  }
  public onInputChange = (event: any) => {
    this.keyboard.setInput(event.target.value);
  }
  private onChange(input: string) {
    this.cancelartimer();
    if (this.teclado === true) {
      this.value = input;
      this.filterTiendas(input);
      this.filterAccesos(input);
      this.filterEventos(input);
    }
  }
 

  private filterTiendas(input: string) {
    input = input.toUpperCase();
    if (!input || input === '') {
      this.comienzan = true;
      this.contienentienda = false;
      this.tienetag = false;
      this.contienen = [];
      this.contienentags = [];
      return (this.otherTiendasresult = this.listadetiendas);
    }
    let tiendasfiltrar = this.listadetiendas.slice();
    // filtrar si empiezan
    this.otherTiendasresult = tiendasfiltrar.filter((tienda: Tienda) => {
      const nombretienda = this.eliminarDiacriticos(tienda.nombre);
      return nombretienda.toUpperCase().indexOf(input) === 0;
    });
    if (this.otherTiendasresult.length > 0) {
      this.comienzan = true;
    } else {
      this.comienzan = false;
    }
    tiendasfiltrar = this.eliminartienda(tiendasfiltrar, this.otherTiendasresult);
    // filtrar si contienen
    this.contienen = tiendasfiltrar.filter((tienda: Tienda) => {
      const nombretienda = this.eliminarDiacriticos(tienda.nombre);
      return nombretienda.toUpperCase().includes(input) === true;
    });
    if (this.contienen.length > 0) {
      this.contienentienda = true;
    } else {
      this.contienentienda = false;
    }
    tiendasfiltrar = this.eliminartienda(tiendasfiltrar, this.contienen);
    // filtrar por tags
    if (input.length > 1) {
      this.contienentags = tiendasfiltrar.filter((tienda: Tienda) => {
        const mastiendas = tienda.tags.filter((tagstiendas) => {
          const tag = this.eliminarDiacriticos(tagstiendas);
          return tag.toUpperCase().includes(input) === true;
        });
        if (mastiendas.length !== 0) {
          const sindidactricos = [];
          for (const tagsin of mastiendas) {
            sindidactricos.push(this.eliminarDiacriticos(tagsin));
          }
          tienda.tags = sindidactricos;
          return tienda;
        }
      });
    }
    if (this.contienentags.length > 0) {
      this.tienetag = true;
    } else {
      this.tienetag = false;
    }
  }
  eliminarDiacriticos(texto) {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g,"");
  }

  eliminartienda(tiendasporfiltrar: any, tiendasfiltradas: any) {
    for (const tienda of tiendasfiltradas ) {
      if (tiendasporfiltrar.indexOf(tienda)) {
        const ubicacion = tiendasporfiltrar.indexOf(tienda);
        tiendasporfiltrar.splice( ubicacion, 1 );
      }
    }
    return tiendasporfiltrar;
  }







  private filterAccesos(input: string) {
    input=input.toUpperCase();
    if (!input) {
      return this.resultAccesos = this.accesosfiltrados;
    }
    this.resultAccesos = this.accesosfiltrados.filter((TipoAccesos: TipoAccesos) => {
      return TipoAccesos.nombre.toUpperCase().indexOf(input) !== -1;
    });
  }

  private filterEventos(input: string) {
    input=input.toUpperCase();
    if (!input) {
      return this.eventosresult=this.listaeventos;
    }
    this.eventosresult = this.listaeventos.filter((eventos) => {
      return eventos.nombre.toUpperCase().indexOf(input) !== -1;
    });
  }
  public sortByKey(array) {
    return array.sort( function(a, b) {
        const x = a.nombre;
        const y = b.nombre;
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }
  
   // logica de reinicio
   scrollevent = (event: any): void => {
    this.cancelartimer();
  }
  public cancelartimer(){
    this.totemService.emitirReinicioTotem();
  }
}
